/**
 * @contract
 *   Назначение: Клиентский компонент формы поиска ЧОП по ИНН
 *   Используется: page.tsx (tools/proverka-chop)
 *   Аудитория: Посетители, проверяющие ЧОП по ИНН
 */

'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Search } from 'lucide-react';

export function InnSearchForm() {
  const [inn, setInn] = useState('');
  const [error, setError] = useState('');
  const router = useRouter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = inn.trim().replace(/\D/g, '');

    if (!/^\d{10,12}$/.test(trimmed)) {
      setError('Введите корректный ИНН (10 или 12 цифр)');
      return;
    }

    setError('');

    // Яндекс.Метрика — цель поиска по ИНН
    try {
      (window as any).ym?.(107253138, 'reachGoal', 'proverka_inn_search');
    } catch {
      // Метрика не загружена — не критично
    }

    router.push(`/chop/${trimmed}`);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1 relative">
          <input
            type="text"
            inputMode="numeric"
            value={inn}
            onChange={(e) => {
              setInn(e.target.value);
              if (error) setError('');
            }}
            placeholder="Введите ИНН (10 или 12 цифр)"
            maxLength={12}
            className="w-full h-14 px-5 bg-[hsl(var(--portal-surface))] border border-[hsl(var(--portal-border))] text-[hsl(var(--portal-text))] placeholder:text-[hsl(var(--portal-text-dim))] font-mono tabular-nums text-lg tracking-wider uppercase focus:outline-none focus:border-[hsl(var(--portal-accent))] focus:ring-0 transition-colors"
            autoComplete="off"
            aria-label="ИНН частного охранного предприятия"
          />
        </div>
        <button
          type="submit"
          className="h-14 px-8 bg-[hsl(var(--portal-accent))] text-[hsl(var(--portal-accent-on))] hover:bg-[hsl(var(--portal-accent-hover))] uppercase tracking-widest text-xs font-bold shadow-[4px_4px_0_hsl(var(--portal-accent-hover))] transition-colors flex items-center justify-center gap-3 shrink-0"
        >
          <Search className="h-4 w-4" strokeWidth={1.5} />
          Проверить
        </button>
      </div>
      {error && (
        <p className="text-[hsl(var(--portal-danger))] text-xs mt-3 font-sans flex items-center gap-2">
          <span className="w-1 h-1 bg-[hsl(var(--portal-danger))] shrink-0" />
          {error}
        </p>
      )}
    </form>
  );
}